export { DEFAULT_THEME, THEME } from './model/config';
export { resolveTheme, type Theme } from './model/resolveTheme';
export { useTheme } from './model/useTheme';
